__turbopack_context__.v({
  "className": "primaryfont_9b9906d5-module__yXtfpG__className",
});
